import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "gatsby";
import { faArrowRight, faCalendarAlt, faCoins, faEuro } from "@fortawesome/pro-light-svg-icons";
import { getEventoPath } from "../../utils/eventi";
import Accordion from "react-bootstrap/Accordion";
import { StaticImage } from "gatsby-plugin-image";

function EventiGridItem({ evento }) {
  return (
    <div className="col-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
      <div className="card border-secondary mb-3">
        <div className="card-header">
          <h3 className="text-truncate" title={evento.titolo_evento}>
            {evento.titolo_evento}
          </h3>
          <p className="m-0 text-muted">
            ID Evento: {evento.id_evento} Edizione: {evento.numero_edizione}
          </p>
        </div>
        <div className="position-relative">
          <StaticImage
            src="../../images/logo-ecm.png"
            className="card-img"
            alt={`Corso ECM ${evento.titolo_evento}`}
            title={`Corso ECM ${evento.titolo_evento}`}
          />
        </div>
        <div className="card-body">
          <p
            className="mb-0 fw-bold text-truncate"
            title={evento.ragione_sociale}
          >
            {evento.ragione_sociale}
          </p>
          <p className="mb-2 text-muted">Provider N. {evento.provider_id}</p>
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header className="px-0">
                Discipline ({evento.professioni.length})
              </Accordion.Header>
              <Accordion.Body>
                <ul className="list-unstyled">
                  {evento.professioni.map(({ professione, disciplina }) => (
                    <li key={disciplina}>
                      {professione}: {disciplina}
                    </li>
                  ))}
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <p className="mb-1">
            <FontAwesomeIcon icon={faCalendarAlt} className="mr-2" fixedWidth />{" "}
            {evento.data_inizio} - {evento.data_fine}
          </p>
          <p className="mb-1">
            <FontAwesomeIcon icon={faCoins} className="mr-2" fixedWidth />{" "}
            Crediti ECM: {evento.crediti}
          </p>
          <p className="mb-3">
            <FontAwesomeIcon icon={faEuro} className="mr-2" fixedWidth /> Costo:{" "}
            {evento.quota_partecipazione && evento.quota_partecipazione !== "0,00 €"
              ? evento.quota_partecipazione
              : "Gratuito"}
          </p>
          <Link
            to={getEventoPath(evento.tipo_evento, evento.slug)}
            className="btn btn-outline-primary mx-auto"
          >
            Vedi dettaglio <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default function EventiGrid({ eventi }) {
  return (
    <div className="container-fluid">
      <div className="row">
        {eventi.map((evento) => (
          <EventiGridItem key={evento.id} evento={evento} />
        ))}
      </div>
    </div>
  );
}
